export const comments_5480350 = {"data":{"data":[],"links":{}}}